import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateVendorStatus = createAsyncThunk('updateVendorStatus', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `update_vendor_status/${data?.id}`,
            data: { "status": data?.status },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
